import { MultibankingApiProvider } from "@api";
import { BankWrapper } from "@rentablo/api/apiv1";

export type Bank = Pick<
  BankWrapper,
  | "id"
  | "multibankingApiProvider"
  | "bic"
  | "slug"
  | "name"
  | "isSupported"
  | "iconUrl"
  | "bicGroup"
  | "enforceTppWebForm"
>;

export interface ShortBank {
  bic?: string;
  slug?: string;
  multibankingApiProvider: MultibankingApiProvider;
  id?: number;
  isSupported: boolean;
  bicGroup?: string;
  enforceTppWebForm?: boolean;
}

export interface GroupedBank {
  ids: (number | undefined)[];
  name: string;
  banks: ShortBank[];
  iconUrl?: string;
  bicGroup?: string;
  enforceTppWebForm?: boolean;
}

const mapToGroupedBank = (value: Bank, acc: GroupedBank[]): GroupedBank[] => {
  const banks = [
    {
      id: value.id,
      multibankingApiProvider: value.multibankingApiProvider,
      slug: value.slug,
      bic: value.bic,
      isSupported: !!value.isSupported,
      enforceTppWebForm: value.enforceTppWebForm,
    },
  ];

  return [
    ...acc,
    {
      ids: [value.id],
      name: value.name,
      banks,
      iconUrl: value.iconUrl,
      bicGroup: value.bicGroup,
      enforceTppWebForm: value.enforceTppWebForm,
    },
  ];
};

export const groupBankByName = (banks?: Bank[]): GroupedBank[] => {
  if (!banks) return [];

  return banks.reduce((acc, value) => {
    const existing = acc.find(({ name }) => name === value.name);

    if (!existing) {
      return mapToGroupedBank(value, acc);
    }

    existing.ids?.push(value.id);

    existing.banks?.push({
      bic: value.bic,
      slug: value.slug,
      multibankingApiProvider: value.multibankingApiProvider,
      id: value.id,
      isSupported: !!value.isSupported,
      bicGroup: value.bicGroup,
      enforceTppWebForm: value.enforceTppWebForm,
    });

    return acc;
  }, [] as GroupedBank[]);
};
